import { createFileRoute } from '@tanstack/react-router'

import { PageHeader } from '@ems/ui/patterns/page-header'

import { OnboardingSkeleton } from '#admin/features/exhibitor/exhibitor-skeletons.tsx'
import {
  ExhibitorDesk,
  prefetchExhibitorDesk,
} from '#admin/features/exhibitor/onboarding/exhibitor-desk.tsx'

/**
 * `/exhibition/exhibitors/new` — the onboarding desk. One page books an exhibitor from the
 * company to the badges, for example when the exhibitor comes to the desk or calls.
 */
export const Route = createFileRoute('/_authenticated/exhibition/exhibitors/new')({
  pendingComponent: OnboardingSkeleton,
  staticData: { crumb: 'New exhibitor' },
  loader: ({ context }) => prefetchExhibitorDesk(context.queryClient),
  component: NewExhibitorPage,
})

function NewExhibitorPage() {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="New exhibitor"
        description="Book the stands, order the services, settle the payment and issue the badges in one step."
      />
      <ExhibitorDesk />
    </div>
  )
}
